// extracted by mini-css-extract-plugin
export default {"warp":"preset_apps_warp__4SVDS","home_title":"preset_apps_home_title__L1u7Z","foot":"preset_apps_foot__l7tPL"};